<template>
  <div class="stats__diagram__rating">
    <span class="rating-label">{{ $t("stats.labels.rank") }}</span>
    <span class="rating-value">{{ statsData.rating }}</span>
    <span class="rating-top">{{ $t("stats.labels.top") }} {{ statsData.top }}%</span>
  </div>
</template>

<script>
export default {
  name: "StatsRating",

  props: {
    statsData: Object,
  },
};
</script>
